import { render, staticRenderFns } from "./BaseROInputWrap.vue?vue&type=template&id=1e6409aa&scoped=true&"
import script from "./BaseROInputWrap.vue?vue&type=script&lang=js&"
export * from "./BaseROInputWrap.vue?vue&type=script&lang=js&"
import style0 from "./BaseROInputWrap.vue?vue&type=style&index=0&id=1e6409aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6409aa",
  null
  
)

export default component.exports